import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import Tags from '../common/dtmTags';
import ProductDirectoryImage from './ProductDirectoryImage';

class ProductDirectoryVideoThumbnail extends React.Component {
    thumbnailOnClick=() => {
      this.props.onClick(this.props.productVideoSourceUrl, this.props.productVideoPosterImageUrl, this.props.productVideoId);
    }
    render() {
      const {
        product, src, alt, imageSize, translations, isRounded, deviceType, productId, exhibitorId
      } = this.props;
      return (
        <div className={Classes.videoThumbnail}>
          <ProductDirectoryImage
            product={product}
            src={src}
            imageSize={imageSize}
            alt={alt}
            translations={translations}
            isRounded={isRounded}
            deviceType={deviceType}
          />
          <div className={Classes.productVideoThumbnailPlay}>
            <i
              aria-hidden="true"
              onClick={this.thumbnailOnClick}
              className={Classes.videoPlayIcon}
              data-dtm={Tags.productDirectory.video}
              data-dtm-attributes={JSON.stringify({ exhibitorId, productId })}
            />
          </div>
        </div>);
    }
}
ProductDirectoryVideoThumbnail.propTypes = {
  productId: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  imageSize: PropTypes.string.isRequired,
  alt: PropTypes.string,
  isRounded: PropTypes.bool,
  deviceType: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    buttons: PropTypes.shape({
      edit: PropTypes.string
    }),
    innovativeClipText: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  productVideoSourceUrl: PropTypes.string,
  productVideoPosterImageUrl: PropTypes.string,
  productVideoId: PropTypes.string.isRequired,
  exhibitorId: PropTypes.string
};
export default ProductDirectoryVideoThumbnail;
